import React from "react";
import styles from "./EmailInput.module.css";
const EmailInput = ({
  label,
  handleChange,
  value,
  type = "email",
  name = "email",
  placeholder="Enter your work email",
  ...props
}) => {
  return (
    <>
      <label className={styles.label}>{label}</label>
      <input
        className={styles.input}
        type={type}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        {...props}
      />
    </>
  );
};

export { EmailInput };
